import { Link } from 'react-router';
import { ReactComponent as ArrowRight } from '@rocco/icons/svg/arrow/arrow-right-sm.svg';

const NotFound = () => {
    return (
        <div className="page-wrapper">
            <div className="main-wrapper">
                <section className="relative min-h-screen w-full overflow-x-hidden">
                    <div className="relative z-10 flex h-full min-h-screen w-full flex-col items-center justify-center text-white">
                        <div className="container mx-auto flex flex-col items-center justify-center px-4 py-8">
                            <h1 className="my-[3.67rem] mb-[3.67rem] text-[8rem] font-normal leading-none tracking-[-2px] md:mb-10 md:text-[15rem]">
                                404
                            </h1>
                            <p className="mb-6 px-4 py-[1.5rem] text-center text-base leading-[1.3] tracking-[0.36px] md:mb-8 md:py-[1.5rem] md:text-[1.125rem]">
                                Sorry, this page has been moved or does not
                                exist.
                            </p>
                            <Link
                                to="/"
                                className="group flex items-center gap-2 rounded-full bg-[rgb(216,127,92)] px-6 py-2.5 text-sm text-black transition-all hover:bg-[rgb(216,127,92)]/90 hover:text-white md:px-9 md:py-3 md:text-base"
                            >
                                Back to Homepage
                                <ArrowRight />
                            </Link>
                        </div>
                    </div>

                    {/* Video Background */}
                    <div className="absolute inset-0 h-full w-full">
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="h-full w-full object-cover"
                            poster={`/assets/website/ui/error-page/error-page-background.jpg`}
                        >
                            <source
                                src={`/assets/website/ui/error-page/error-page-background.webm`}
                                type="video/webm"
                            />
                            <source
                                src={`/assets/website/ui/error-page/error-page-background.mp4`}
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default NotFound;
